// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZSJXT0H4gNGZzxfB{display:flex;align-items:center;justify-content:center;height:100%}.HLCGICUX0ysg58Fn{height:100%;display:flex;justify-content:space-between;align-items:flex-end}.HLCGICUX0ysg58Fn .ZW2wXpD07IAcKEKz{width:50%;height:56px;display:flex;align-items:center;justify-content:center}.HLCGICUX0ysg58Fn .CPKIaOR46tsFAcWn{display:flex;flex-direction:column;gap:4px;line-height:16px;font-size:12px;font-weight:600}.HLCGICUX0ysg58Fn h1{line-height:48px;font-size:48px;letter-spacing:-2.4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `ZSJXT0H4gNGZzxfB`,
	"kpiContainer": `HLCGICUX0ysg58Fn`,
	"spinRow": `ZW2wXpD07IAcKEKz`,
	"progressContainer": `CPKIaOR46tsFAcWn`
};
export default ___CSS_LOADER_EXPORT___;
